<script setup lang="ts">
import { useSchedulesTree } from './../model/model.ts'
import SchedulesTreeItem from './SchedulesTreeItem.vue'
import SchedulesTreeContext from './SchedulesTreeContext.vue'

const tree = useSchedulesTree()

const { isLoading } = tree.load()
</script>

<template>
  <div class="v-tree">
    <div class="v-tree__loading" v-if="isLoading">
      <VProgressCircular color="white" indeterminate :size="30" :width="3" />
    </div>

    <template v-else>
      <SchedulesTreeItem v-for="item in tree.objects" :item="item" :key="item.id" />
    </template>

    <SchedulesTreeContext />
  </div>
</template>
